module.exports = __webpack_public_path__ + "img/slide1.2baa6af7.png";